import { MenuListProps, MenuProps } from 'react-select/src/components/Menu';
import {
    OptionBoxHoverWrapper,
    OptionBoxWrapper,
    OptionsBoxListWrapper,
    OptionsBoxWrapper,
} from '../styles';
import { OptionProps } from 'react-select';
import { FC } from 'react';
import { Colors, FInter } from '@brg/ui';

/**
 * Опция
 *
 * @param innerRef
 * @param innerProps
 * @param children
 * @param isFocused
 * @constructor
 */
export const OptionBox = ({ innerRef, innerProps, children, isFocused }: OptionProps<any, any>) => {
    return isFocused ? (
        <OptionBoxHoverWrapper {...innerRef} {...innerProps}>
            {children}
        </OptionBoxHoverWrapper>
    ) : (
        <OptionBoxWrapper {...innerRef} {...innerProps}>
            {children}
        </OptionBoxWrapper>
    );
};

//
// Разницу между этими двумя компонентами я не очень полян. Но пусть будет
//
export const OptionsBox = (props: MenuProps<any, any>) => {
    const { innerRef, innerProps, children } = props;
    return (
        <OptionsBoxWrapper ref={innerRef} {...innerProps}>
            {/*<OptionsBoxShadow>&nbsp;</OptionsBoxShadow>*/}
            {children}
        </OptionsBoxWrapper>
    );
};

export const OptionsListBox: FC<MenuListProps> = ({ innerRef, children }) => {
    return <OptionsBoxListWrapper ref={innerRef}>{children}</OptionsBoxListWrapper>;
};

/**
 * Сообщение что ничего не найдено
 * @constructor
 */
export const NoOptionsMessage: FC = () => {
    return (
        <FInter.SmallTextFlex color={Colors.geoWhite31} style={{ paddingLeft: '16px' }} height={48} align={'center'}>
            No such position
        </FInter.SmallTextFlex>
    );
};
import { MenuListProps, MenuProps } from 'react-select/src/components/Menu';
import {
    OptionBoxHoverWrapper,
    OptionBoxWrapper,
    OptionsBoxListWrapper,
    OptionsBoxWrapper,
} from '../styles';
import { OptionProps } from 'react-select';
import { FC } from 'react';
import { Colors, FInter } from '@brg/ui';

/**
 * Опция
 *
 * @param innerRef
 * @param innerProps
 * @param children
 * @param isFocused
 * @constructor
 */
export const OptionBox = ({ innerRef, innerProps, children, isFocused }: OptionProps<any, any>) => {
    return isFocused ? (
        <OptionBoxHoverWrapper {...innerRef} {...innerProps}>
            {children}
        </OptionBoxHoverWrapper>
    ) : (
        <OptionBoxWrapper {...innerRef} {...innerProps}>
            {children}
        </OptionBoxWrapper>
    );
};

//
// Разницу между этими двумя компонентами я не очень полян. Но пусть будет
//
export const OptionsBox = (props: MenuProps<any, any>) => {
    const { innerRef, innerProps, children } = props;
    return (
        <OptionsBoxWrapper ref={innerRef} {...innerProps}>
            {/*<OptionsBoxShadow>&nbsp;</OptionsBoxShadow>*/}
            {children}
        </OptionsBoxWrapper>
    );
};

export const OptionsListBox: FC<MenuListProps> = ({ innerRef, children }) => {
    return <OptionsBoxListWrapper ref={innerRef}>{children}</OptionsBoxListWrapper>;
};

/**
 * Сообщение что ничего не найдено
 * @constructor
 */
export const NoOptionsMessage: FC = () => {
    return (
        <FInter.SmallTextFlex color={Colors.geoWhite31} style={{ paddingLeft: '16px' }} height={48} align={'center'}>
            No such position
        </FInter.SmallTextFlex>
    );
};
